export default function () {
  const chapterMarkers = document.querySelectorAll(".chapter-item");
  const chapters = document.querySelectorAll(".chapter-contents__block");
  const chapterMarker = document.getElementById("chapter-scroll__marker");
  
  let chapterContainer = document.getElementById('chapter-scroll__container');
  let scrollWidth;
  let markerWidth;

  function setScroll(chapterContainer) {
    // calculate the width of the scroll container
    scrollWidth = chapterContainer.clientWidth;
    // divide by # of chapters
    markerWidth = scrollWidth / chapterMarkers.length;
    return; 
  }
  
  const observer = new IntersectionObserver((entries, observer) => {
    if (chapterContainer) {
      setScroll(chapterContainer);
    }

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const chapterIndex = Array.from(chapters).indexOf(entry.target);

        chapterMarkers.forEach(marker => {
          marker.classList.remove("activeTab");
        });
        chapterMarkers[chapterIndex].classList.add("activeTab");
        if (chapterMarker) {
          chapterMarker.style.left = `${markerWidth*chapterIndex}px`;
        }

        chapters.forEach(chapter => {
          chapter.classList.remove("activeTab");
        });
        chapters[chapterIndex].classList.add("activeTab"); 
      }
    });

  }, {
    // when half of the item height crosses half of the viewport
    rootMargin: "0px 0px -50% 0px",
    threshold: .35
  });
  
  const fn = {
    init: function () {
      if (chapterContainer) {
        setScroll(chapterContainer);
      }

      // manually apply width to the marker
      if (chapterMarker) {
        chapterMarker.style.width = `${markerWidth}px`;
      }

      chapterMarkers.forEach(marker => {
        marker.addEventListener("click", function handleClick(event) {
          const chapterMarkerIndex = Array.from(chapterMarkers).indexOf(event.currentTarget);
          chapterMarkers.forEach(marker => {
            marker.classList.remove("activeTab")
          });

          chapters.forEach(chapter => {
            chapter.classList.remove("activeTab");
          });
          chapters[chapterMarkerIndex].classList.add("activeTab");
          event.currentTarget.classList.add("activeTab");

          // sets chapter marker in position
          if (chapterMarker) {
            chapterMarker.style.left = `${markerWidth*chapterMarkerIndex}px`;
          }
        });
      });
      chapters.forEach(chapter => {
        observer.observe(chapter);
      });
    }
  }

  if (chapters.length > 0) {
    fn.init();
  }
}
